export default __webpack_public_path__ + "alberta-dialysis.41b8ec2f50dec8fda05d.svg";